import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { IProps } from '../common/props';
import { RowColWidths, rowColWidths } from './utils';

type stringOrNumberProp = number | string;

type ColumnSizeProps =
  | boolean
  | number
  | 'auto'
  | string
  | {
      size: boolean | number | string;
      order: stringOrNumberProp;
      offset: stringOrNumberProp;
    };

export interface IColProps extends IProps {
  xs?: ColumnSizeProps;
  sm?: ColumnSizeProps;
  md?: ColumnSizeProps;
  lg?: ColumnSizeProps;
  xl?: ColumnSizeProps;
  widths?: RowColWidths[];
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}
export type ColProps = IColProps;

const getColumnSizeClass = (
  isXs: boolean,
  colWidth: string | number | boolean,
  colSize: string | number | boolean
) => {
  if (colSize === true || colSize === '') {
    return isXs ? Classes.GRID_COL : `${Classes.GRID_COL}-${colWidth}`;
  } else if (colSize === 'auto') {
    return isXs
      ? `${Classes.GRID_COL}-auto`
      : `${Classes.GRID_COL}-${colWidth}-auto`;
  }

  return isXs
    ? `${Classes.GRID_COL}-${colSize}`
    : `${Classes.GRID_COL}-${colWidth}-${colSize}`;
};

export const Col: React.FC<ColProps> = ({ className, ...props }) => {
  const cls = classNames(Classes.COL, className, {});

  const { widths = rowColWidths, ...attributes } = props;
  const colClasses = [];

  widths.forEach((colWidth, i) => {
    // @ts-ignore
    let columnProp = props[colWidth];
    // @ts-ignore
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    const isXs = !i;

    if (typeof columnProp === 'object') {
      const colSizeInterfix = isXs ? '-' : `-${colWidth}-`;
      const colClass = getColumnSizeClass(isXs, colWidth, columnProp.size!);

      colClasses.push(
        classNames({
          [colClass]: columnProp.size || columnProp.size === '',
          [`order${colSizeInterfix}${columnProp.order}`]:
            columnProp.order || columnProp.order === 0,
          [`offset${colSizeInterfix}${columnProp.offset}`]:
            columnProp.offset || columnProp.offset === 0,
        })
      );
    } else {
      const colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push(Classes.GRID_COL);
  }

  const classes = classNames(cls, colClasses);

  return <div {...attributes} className={classes} />;
};
